import { render, staticRenderFns } from "./PropSelectItem.vue?vue&type=template&id=3a4d3e19&scoped=true"
import script from "./PropSelectItem.vue?vue&type=script&lang=ts"
export * from "./PropSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./PropSelectItem.vue?vue&type=style&index=0&id=3a4d3e19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d3e19",
  null
  
)

export default component.exports